import { ActionReducerMap } from '@ngrx/store';
import { signedInUserReducer, SignedInUserState, MainState } from '@pit/frontend-shared';

export const reducers: ActionReducerMap<MainState> = {
  signedInUser: signedInUserReducer
}

export * from '@pit/frontend-shared';
